import { DateTime } from 'luxon';
import React from 'react';
import styled from 'styled-components';
import { stringFormatter } from '../formatters';
import { KeysColor } from '../GraphKeys/GraphKeys';
const Container = styled.div.attrs((props) => ({
    style: {
        left: `${props.x + 2}px`,
        top: `${props.y + 4}px`,
    },
})) `
  position: absolute;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.12);
  padding: 12px;
  opacity: 0.9;
`;
const Title = styled.h5 `
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
  margin-bottom: 12px;
`;
const Item = styled.div `
  margin: 0 0 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:last-child {
    margin-bottom: 0;
  }
`;
const KeyColorAndName = styled.div `
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-right: 12px;
  white-space: nowrap;
`;
const Value = styled.div `
  font-size: 11px;
  color: currentColor;
`;
export const GraphTooltip = (props) => {
    const { rows, coords } = props;
    const day = rows.length > 0 && rows[0].day;
    const title = (day &&
        DateTime.fromJSDate(day, { zone: 'UTC' }).toFormat('cccc, MMM dd')) ||
        '';
    const valueFormatter = props.valueFormatter ?? stringFormatter;
    return (React.createElement(Container, { x: coords[0], y: coords[1] },
        React.createElement(Title, null, title),
        rows.map((row, i) => (React.createElement(Item, { key: i },
            React.createElement(KeyColorAndName, null,
                React.createElement(KeysColor, { color: row.dataSet.color }),
                " ",
                row.dataSet.name),
            React.createElement(Value, null, valueFormatter(row.value)))))));
};
